module.exports = {
  MALE: 'male',
  FEMALE: 'female',
  OTHER: 'other'
}
